import './BookChartsCard.scss'

const BookChartsCard = ({ title, iconClasses, statistic, description }) => {
  return (
    <div className='book-charts-card'>
      <div className='charts-card-header'>
        <p>{title}</p>
        <i className={iconClasses}></i>
      </div>
      <div className='charts-card-content'>
        <h4>{statistic}</h4>
        {description && <p>{description}</p>}
      </div>
    </div>
  )
}

export default BookChartsCard
